import React from 'react'
import Chip from '@mui/material/Chip'
import { DemandRequestLineItemStatus } from '../../../graphql'
import { LineItem } from '../../../types/demandRequest'

type Props = {
	lineItem: LineItem
}

// `size="small"` (24px) is MUI's smallest built-in Chip size. Its default label
// text (13px) reads a little small next to this table's 0.9375rem body text, so
// bump it up slightly rather than shrinking the chip further.
const COMPACT_CHIP_SX = {
	fontSize: '0.875rem',
}

export default function LineItemStatusBadge( { lineItem }: Props ) {
	const { status, fulfilledQuantity, isCompleted, inFlightFulfillmentOrderCount, inFlightTransferOrderCount } = lineItem

	if ( status === DemandRequestLineItemStatus.Cancelled ) {
		return <Chip size="small" sx={COMPACT_CHIP_SX} color="default" label="Cancelled" />
	}

	if ( status === DemandRequestLineItemStatus.Completed || isCompleted ) {
		return <Chip size="small" sx={COMPACT_CHIP_SX} color="success" label="Fulfilled" />
	}

	// Any partial progress reads as "Partially Fulfilled". The `outstandingQuantity` value is
	// not required here: an item with fulfilledQuantity > 0 should never fall through to
	// "No Activity", even in the edge case where outstandingQuantity is 0 but the server has
	// not (yet) flagged isCompleted.
	if ( fulfilledQuantity > 0 ) {
		return <Chip size="small" sx={COMPACT_CHIP_SX} color="warning" label="Partially Fulfilled" />
	}

	if ( inFlightFulfillmentOrderCount > 0 || inFlightTransferOrderCount > 0 ) {
		return <Chip size="small" sx={COMPACT_CHIP_SX} color="primary" label="In Flight" />
	}

	return <Chip size="small" sx={COMPACT_CHIP_SX} color="default" label="No Activity" />
}
